import { useState } from 'react';

import { CronJobName, CronJobPayload } from '../CronJobsCRUDForm.types';

import CronJobsCRUD from '../CronJobsCRUD';
import { cleanupCronJobsSchema } from './CleanupCronJobsSchema';
import CleanupFormSection from './CleanupFormSection';

const CleanupCronJobs = () => {
  const [selectedJobType, changeJobType] = useState<CronJobName | undefined>(
    undefined
  );
  const defaultValues: Partial<CronJobPayload> = {
    jobName: selectedJobType,
    count: undefined,
    cutoffDate: '',
    batchSize: undefined,
    max: undefined,
    maxTime: undefined,
    cron: '',
    config: {
      tenantId: 'dzz',
      minusDays: '0',
      plusDays: '0'
    }
  };

  return (
    <CronJobsCRUD
      schema={cleanupCronJobsSchema()}
      defaultFormValues={cleanupCronJobsSchema().cast(defaultValues)}
    >
      <CleanupFormSection
        selectedJobType={selectedJobType}
        changeJobType={changeJobType}
      />
    </CronJobsCRUD>
  );
};

export default CleanupCronJobs;
